import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, FormattedMessage, IntlShape} from 'react-intl';
import {MiniPanel} from '../EmbededPanel.react';
import {wrapNotFound} from '../../app/NotFoundHandler.react';
import {lastPanelController} from '../EmbededPanelController';
import './PanelTooltip.scss';

const messages = defineMessages({
    emailSubject: {id: 'screenSettings.ListWithoutPanel.dataSourceRemove.emailSubject', 'defaultMessage': 'Suggestion what to show on {service} in {name}'},
});

class ListWithoutPanel extends React.Component {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

		let self = this;
        this.state = {
            'visibleTooltip': false,
			'messageReceiver': (event) => { self.receiveMessage(event); } // function needs stable reference for removing event listener
        };
    }

	componentDidMount() {
		if (window.addEventListener) {
			addEventListener("message", this.state.messageReceiver, false);
		} else {
			attachEvent("onmessage", this.state.messageReceiver); // eslint-disable-line no-undef
		}
	}

	componentWillUnmount() {
		lastPanelController().tooltip = false;
		if (window.removeEventListener) {
			removeEventListener("message", this.state.messageReceiver);
		}
		else {
			detachEvent("onmessage", this.state.messageReceiver);
		}
	}

	receiveMessage(event) {
		if (event.data.msg === 'dativeryInvokeEvent') {
			this.setState({
				visibleTooltip: false
			});
		}
	}

	config = () => {
		this.setState({
			visibleTooltip: !this.state.visibleTooltip
		});
    };

	closeTooltip = (proxy) => {
		if (proxy.target.tagName.toLowerCase() !== 'a') {
			this.config();
		}
	}

	render() {
        return (
            <div className="panelWithTooltip">
				<MiniPanel className={this.state.visibleTooltip ? 'visibleTooltip' : ''} config={this.config} hideMenu typeForTest="panel-without-list" visibleTooltip={this.state.visibleTooltip}>
				</MiniPanel>
				{this.state.visibleTooltip ?
					<div className="tooltipWrapper" onClick={this.closeTooltip}>
						<div className="tooltipItem">
							<div className="close"><i className="fa fa-times"></i></div>
							<FormattedMessage defaultMessage="What would you like to have here?" id="screenSettings.ListWithoutPanel.suggestion" /> <a href={"mailto:support@dativery.com?subject=" + encodeURIComponent(this.props.intl.formatMessage(messages.emailSubject, {name: this.props.user.channelDef.channelMappingDef.sourceDef.name, service: this.props.user.channelDef.name}))} target="_top"><i className="fa fa-envelope-o"></i></a><br />
							<FormattedMessage defaultMessage="The {name} is supported for this {service} list." id="screenSettings.ListWithoutPanel.supported" values={{name: this.props.user.channelDef.channelMappingDef.sourceDef.name, service: this.props.user.channelDef.name}} />
						</div>
					</div>
				: null}
			</div>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ListWithoutPanel), (props) => {
    return props.user.channelDef && props.user.channelDef.channelMappingDef;
}), {
    initialVariables: {
		channelDefId: '',
        channelMappingDefId: '',
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
				channelDef(id: $channelDefId) {
                    name,
                    channelMappingDef(id: $channelMappingDefId) {
                        sourceDef {
                            name
                        }
                    }
                }
            }
        `
    }
});
